import { motion } from 'framer-motion';
import { Bot, Zap, MessageSquareWarning, CreditCard } from 'lucide-react';
import { Link } from 'react-router-dom';

const items = [
  {
    icon: Bot,
    title: 'AI-agent för kundtjänst',
    status: 'Pågår',
    statusColor: 'text-indigo-600 bg-indigo-50',
    dot: 'bg-indigo-400 animate-pulse',
    desc: 'Svarar kunder dygnet runt, loggar ärenden och eskalerar undantag.',
    gradient: 'from-indigo-500 to-violet-600',
  },
  {
    icon: Zap,
    title: 'Intern admin-automation',
    status: 'Pågår',
    statusColor: 'text-amber-700 bg-amber-50',
    dot: 'bg-amber-400 animate-pulse',
    desc: 'Automatiserar rapporter, statusuppdateringar och manuella flöden.',
    gradient: 'from-amber-400 to-orange-500',
  },
  {
    icon: MessageSquareWarning,
    title: 'Klagobot',
    status: 'Live',
    statusColor: 'text-emerald-700 bg-emerald-50',
    dot: 'bg-emerald-400',
    desc: 'AI-verktyg som skriver klagomålsbrev och överklaganden.',
    gradient: 'from-indigo-500 to-violet-600',
    href: '/klagobot',
  },
  {
    icon: CreditCard,
    title: 'Swishkassa',
    status: 'Under utveckling',
    statusColor: 'text-violet-700 bg-violet-50',
    dot: 'bg-violet-400 animate-pulse',
    desc: 'Betalningslösning för föreningar och event — lanseras 2025.',
    gradient: 'from-emerald-400 to-teal-500',
    href: '/swishkassa',
  },
];

const ActiveWorkSection = () => (
  <section className="py-20 bg-surface-subtle border-t border-border-light">
    <div className="container mx-auto px-6">

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: '-60px' }}
        transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
        className="text-center mb-12"
      >
        <span className="inline-block text-xs font-semibold tracking-[0.18em] uppercase text-brand-indigo mb-4">
          Just nu
        </span>
        <h2 className="text-3xl sm:text-[38px] font-extrabold text-text-primary tracking-[-0.02em] leading-tight">
          Vad vi jobbar med just nu
        </h2>
      </motion.div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 max-w-5xl mx-auto">
        {items.map(({ icon: Icon, title, status, statusColor, dot, desc, gradient, href }, i) => {
          const card = (
            <motion.div
              key={title}
              whileHover={{ y: -4, transition: { duration: 0.2 } }}
              className="group bg-white rounded-2xl border border-border-light p-6 shadow-sm hover:shadow-lg hover:border-indigo-200 transition-all duration-300 flex flex-col"
            >
              <div className="flex items-start justify-between mb-4">
                <div className={`inline-flex w-10 h-10 rounded-xl bg-gradient-to-br ${gradient} items-center justify-center shadow-md`}>
                  <Icon className="w-4 h-4 text-white" />
                </div>
                <div className="flex items-center gap-1.5">
                  <span className={`w-1.5 h-1.5 rounded-full ${dot}`} />
                  <span className={`text-[10px] font-bold tracking-wide px-2 py-0.5 rounded-full ${statusColor}`}>
                    {status}
                  </span>
                </div>
              </div>
              <h3 className="text-[15px] font-bold text-text-primary mb-2">{title}</h3>
              <p className="text-[13px] text-text-secondary leading-relaxed flex-1">{desc}</p>
              {href && (
                <span className="mt-3 text-[12px] font-semibold text-brand-indigo group-hover:opacity-70 transition-opacity inline-flex items-center gap-1">
                  Läs mer →
                </span>
              )}
            </motion.div>
          );

          return href ? (
            <Link key={title} to={href} className="contents">
              {card}
            </Link>
          ) : (
            <div key={title}>{card}</div>
          );
        })}
      </div>

    </div>
  </section>
);

export default ActiveWorkSection;
